module.exports = __webpack_public_path__ + "media/images/games/dota-2/logo-5145e95edae7510b117aebf38c903943.png";